"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CATEGORY_KEYWORDS = exports.REVIEW_TAGS_CLIENT = exports.REVIEW_TAGS_HANDYMAN = exports.MAX_PORTFOLIO_CASE_IMAGES = exports.MAX_REQUEST_IMAGES = exports.MIN_PORTFOLIO_CASES_FOR_PUBLIC = exports.MIN_PORTFOLIO_IMAGES_FOR_PUBLIC = exports.BROADCAST_RESPONSE_TIMEOUT_HOURS = exports.BROADCAST_MAX_PROVIDERS = exports.CLASSIFICATION_CONFIDENCE_THRESHOLD = exports.VERIFICATION_LEVEL_SCORES = exports.DEFAULT_RANKING_WEIGHTS = void 0;
const enums_1 = require("./enums");
exports.DEFAULT_RANKING_WEIGHTS = {
    categoryMatch: 35,
    serviceZoneMatch: 15,
    verificationLevel: 15,
    ratingAverage: 15,
    responsePerformance: 10,
    completedJobs: 10,
    complaintPenalty: -10,
    cancellationPenalty: -5,
};
exports.VERIFICATION_LEVEL_SCORES = {
    [enums_1.ProviderVerificationLevel.Unverified]: 0,
    [enums_1.ProviderVerificationLevel.IdentityVerified]: 33,
    [enums_1.ProviderVerificationLevel.ProVerified]: 66,
    [enums_1.ProviderVerificationLevel.TrustedPro]: 100,
};
exports.CLASSIFICATION_CONFIDENCE_THRESHOLD = 0.7;
exports.BROADCAST_MAX_PROVIDERS = 10;
exports.BROADCAST_RESPONSE_TIMEOUT_HOURS = 24;
exports.MIN_PORTFOLIO_IMAGES_FOR_PUBLIC = 3;
exports.MIN_PORTFOLIO_CASES_FOR_PUBLIC = 1;
exports.MAX_REQUEST_IMAGES = 5;
exports.MAX_PORTFOLIO_CASE_IMAGES = 10;
exports.REVIEW_TAGS_HANDYMAN = [
    "punctual",
    "quality_work",
    "fair_price",
    "polite",
    "fast_response",
];
exports.REVIEW_TAGS_CLIENT = [
    "clear_request",
    "paid_on_time",
    "respectful",
    "no_show",
];
exports.CATEGORY_KEYWORDS = {
    plumber: [
        "pipe", "pipes", "leak", "leaking", "sink", "toilet", "bathroom",
        "water", "drain", "faucet", "tap", "plumb", "sewage", "tub",
        "țeavă", "robinet", "scurgere", "instalator", "водопровод", "труба",
    ],
    electrician: [
        "electric", "electrical", "outlet", "socket", "wire", "wiring",
        "breaker", "fuse", "light", "switch", "power", "voltage", "circuit",
        "priză", "electrician", "curent", "розетка", "электрик", "провод",
    ],
    appliance_repair: [
        "washing machine", "washer", "dryer", "fridge", "refrigerator",
        "dishwasher", "oven", "microwave", "stove", "appliance", "repair",
        "mașina de spălat", "frigider", "cuptor", "стиральная машина", "холодильник",
    ],
    cleaning: [
        "clean", "cleaning", "maid", "housekeeping", "vacuum", "sweep",
        "mop", "sanitize", "dust", "scrub", "tidy",
        "curățenie", "curăță", "уборка", "чистка",
    ],
    moving: [
        "move", "moving", "relocate", "relocation", "transport", "furniture",
        "boxes", "pack", "unpack", "haul",
        "mutare", "transport", "переезд", "перевозка",
    ],
    taxi: [
        "taxi", "ride", "airport", "uber", "drive", "driver", "car",
        "таксі", "такси", "шофер",
    ],
};
//# sourceMappingURL=constants.js.map